import Vue from 'vue'
import VueRouter from 'vue-router'
import { routers } from './router'
import { store } from '../store/store'

Vue.use(VueRouter)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  var position = {x: 0, y: 0}
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    position = savedPosition
  }

  return new Promise(resolve => {
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }

    // wait for the out transition to complete (if necessary)
    router.app.$root.$once('triggerScroll', () => {
      router.app.$nextTick(() => resolve(position))
    })
  })
}

// Routing configuration
export const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  /* scrollBehavior: (to, from, savedPosition) => new Promise((resolve) => {
    console.log('scroll behaviour')
    console.log(to)
    console.log(from)
    console.log(savedPosition)
    const position = savedPosition || {}
    if (!savedPosition) {
      if (to.hash) {
        position.selector = to.hash
      }
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        position.x = 0
        position.y = 0
      }
    }
    router.app.$root.$once('triggerScroll', () => {
      router.app.$nextTick(() => resolve(position))
    })
  }), */
  routes: routers
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['auth/loggedIn']) {
      next({
        path: '/auth/sign-in',
        query: { redirect: to.fullPath } // Maybe use this in future to redirect to page you were bounced from
      })
    } else {
      if (!store.getters['db/sync']().synced && to.path !== '/loading') {
        next({
          path: '/loading',
          query: { redirect: to.fullPath } // Maybe use this in future to redirect to page you were bounced from
        })
      } else {
        next()
      }
    }
  } else {
    next() // make sure to always call next()!
  }
})
